(function () {
    /* ============================================
        localStorage helpers
    ============================================ */
    const STORAGE_KEY = 'clube_ratings';

    function getStoredRatings() {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
        } catch {
            return {};
        }
    }

    function getStoredRating(postId) {
        return getStoredRatings()[postId] || 0;
    }

    function storeRating(postId, rating) {
        try {
            const ratings = getStoredRatings();
            ratings[postId] = rating;
            localStorage.setItem(STORAGE_KEY, JSON.stringify(ratings));
        } catch {
            // localStorage unavailable (private mode, storage full, etc.) — fail silently
        }
    }

    /* ============================================
        Interactive rating
    ============================================ */
    function initRating(container) {
        const label         = container.querySelector('.interactive-label');
        const stars         = Array.from(container.querySelectorAll('.star'));
        const postId        = parseInt(container.dataset.postId, 10);
        const currentRating = label ? parseFloat(label.dataset.rating) : 0;

        const userRating = () => getStoredRating(postId);
        const hasRated   = () => userRating() > 0;

        let selected = 0;

        /* ── Update UI ──────────────────────────────────────────── */
        function update(hovered, isHover) {
            stars.forEach((s, i) => {
                s.classList.remove('filled', 'hover');

                if (isHover) {
                    // Already rated: keep their stored choice filled, no hover effect
                    if (hasRated()) {
                        if (i < userRating()) s.classList.add('filled');
                    } else {
                        if (i < hovered) s.classList.add('hover');
                    }
                } else if (selected > 0) {
                    if (i < selected) s.classList.add('filled');
                } else if (currentRating > 0) {
                    if (i < parseInt(currentRating, 10)) s.classList.add('filled');
                }
            });

            if (isHover) {
                const displayRating = hasRated() ? userRating() : hovered;
                label.textContent = `(${displayRating}) ${clubei18n.minhaavaliacao}`;
            } else if (selected === 0 && currentRating === 0) {
                label.textContent = clubei18n.avalie;
            } else {
                label.textContent = selected > 0 ? `(${selected}) ${clubei18n.minhaavaliacao}` : `(${currentRating}) ${clubei18n.avaliacaousuarios}`;
            }

            // Update hidden input value for comment submission
            const ratingInput = document.getElementById('clube_rating');
            if (ratingInput) ratingInput.value = selected;
        }

        /* ── REST API helper ──────────────────────────────────────────── */
        function submitRating(rating) {
            // Early return in case on comment form.
            if (container.closest('#commentform')) { return; }

            // Disable stars while the request is in flight
            stars.forEach(s => (s.style.pointerEvents = 'none'));
            label.textContent = clubei18n.salvando;

            fetch(`${clubeCommon.restApiUrl}/rating`, {
                method:  'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ post_id: postId, rating }),
            })
                .then(res => res.json().then(data => ({ ok: res.ok, data })))
                .then(({ ok, data }) => {
                    // Persist the choice locally on success
                    storeRating(postId, rating);
                    document.dispatchEvent(new CustomEvent('clube:rated', { detail: { postId } }));
                    label.textContent = `(${rating}) ${clubei18n.minhaavaliacao}`;
                    // Lock the stars permanently — user has now rated
                    stars.forEach(s => (s.style.pointerEvents = 'none'));
                    setTimeout(() => update(0, false), 1500);
                })
                .catch(() => {
                    label.textContent = clubei18n.erroConexao;
                    selected = 0;
                    stars.forEach(s => (s.style.pointerEvents = ''));
                    setTimeout(() => update(0, false), 2500);
                });
        }

        /* ── Event listeners ──────────────────────────────────────────── */
        stars.forEach((s, i) => {
            s.addEventListener('mouseenter', () => update(i + 1, true));
            s.addEventListener('click', () => {
                // Silently ignore clicks from users who already rated
                if (hasRated()) return;

                selected = i + 1;
                update(0, false);       // update UI immediately
                submitRating(selected); // fire REST request
            });
        });
        container.addEventListener('mouseleave', () => update(0, false));

        document.addEventListener('clube:rated', ({ detail }) => {
            if (detail.postId !== postId) return;
            selected = userRating();
            stars.forEach(s => (s.style.pointerEvents = 'none'));
            update(0, false);
        });
    }

    document.querySelectorAll('.interactive').forEach(initRating);

    /* ============================================
        Validate rating on comment submission
    ============================================ */
    const commentForm = document.getElementById('commentform');
    if (commentForm) {
        commentForm.addEventListener('submit', (e) => {
            const ratingInput   = commentForm.querySelector('input[name="clube_rating"]');
            const commentParent = commentForm.querySelector('input[name="comment_parent"]');
            if (ratingInput && commentParent && parseInt(commentParent.value, 10) === 0) {
                const ratingValue = parseInt(ratingInput.value, 10);
                if (isNaN(ratingValue) || ratingValue < 1 || ratingValue > 5) {
                    e.preventDefault();
                    alert(clubei18n.selecioneavaliacao);
                }
            }
        });
    }
})();
